'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessageToConversation = publishMessageToConversation;

var _getLiveChatAttachments = require('conversations-schema/pubnub-message/operators/getLiveChatAttachments');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _stageMessageOnStubbedThread = require('../../stubbed-thread-history/actions/stageMessageOnStubbedThread');

var _addAvailabilityMessage = require('../../availability/actions/addAvailabilityMessage');

var _publishMessage = require('../../pubsub/actions/publishMessage');

var _associateFileAttachmentsWithThread = require('../../file-uploads/actions/associateFileAttachmentsWithThread');

function publishMessageToConversation(_ref) {
  var channel = _ref.channel,
      message = _ref.message,
      threadId = _ref.threadId;

  return function (dispatch) {
    if (threadId === _stubbedThreadId.STUBBED_THREAD_ID) {
      dispatch((0, _stageMessageOnStubbedThread.stageMessageOnStubbedThread)(message));
    } else {
      dispatch((0, _associateFileAttachmentsWithThread.associateFileAttachmentsWithThread)({
        attachments: (0, _getLiveChatAttachments.getLiveChatAttachments)(message),
        threadId: threadId
      })).then(function () {
        return dispatch((0, _publishMessage.publishMessage)({ channel: channel, message: message, threadId: threadId }));
      }).then(function () {
        return dispatch((0, _addAvailabilityMessage.addAvailabilityMessage)({ channel: channel, threadId: threadId }));
      }).done();
    }
  };
}